
<template>
  <div>
    <v-card style="border-radius:12px">
      <v-toolbar flat color="white">
        <v-toolbar-title>Fornecedores</v-toolbar-title>
        <v-divider class="mx-4" inset vertical ></v-divider>
        <div class="flex-grow-1"></div>
        <v-btn rounded color="primary" dark class="mb-1" @click="dialog_supplier=true">Novo</v-btn>
      </v-toolbar>

      <v-card-text class="ma-0 py-1">
        <v-row justify="center" v-if="!allSuppliers">
          <v-col cols="12" align="center">
            <card-loading ></card-loading>
          </v-col>
        </v-row>
        <index-table v-if="allSuppliers" :headers="headers" :items="allSuppliers_comp" :deletion_enabled="false" @editing="editing($event)" @deleting="deleting($event)"></index-table>
      </v-card-text>
    </v-card>





    <v-dialog v-model="dialog_supplier" v-if="dialog_supplier" scrollable max-width="600px" transition="dialog-transition" >
      <supplier-profile :dialog_supplier="dialog_supplier" :one_supplier.sync="one_supplier" @close="dialog_supplier = $event"></supplier-profile>
    </v-dialog>

    <dialog-loading v-if="loading" :loadText="loadingText"></dialog-loading>

  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '../../api/index'
import { mask } from 'vue-the-mask'
// string "name"
// jsonb "corporate_info"
// string "phones",
// string "email"
// jsonb "addresses"
// jsonb "bank_account"
// text "comment"

export default {
  name: 'SupplierIndex',
  components: {
    SupplierProfile: () => import('./SupplierProfile'),
    IndexTable: () => import('@/components/shared/IndexTable'),
    // InputPhone: () => import('@/components/shared/InputPhone'),
    // CardAddress: () => import('@/components/shared/CardAddress'),
  },
  directives: {
    mask,
  },
  data() {
    return {
      mask_cpf: '###.###.###-##',
      mask_cnpj: '##.###.###/####-##',

      loading: false,
      loadingText: null,
      dialog_supplier: false,
      headers:[
        { text: 'Nome', width: '20%', align: 'left', sortable: true, value: 'name'},
        { text: 'Telefones', width: '30%', align: 'center', sortable: false, value: 'phones'},
        { text: 'Tags', width: '30%', align: 'center', sortable: false, value: 'tag_list'},
        // { text: 'Documento', width: '30%', align: 'left', sortable: false, value: 'document'},
        { text: 'Ação', width: '5%', value: 'action', sortable: false }
      ],

      one_supplier:{
        name: null,
        is_natural: true,
        corporate_info: {},
        phones: [],
        email: null,
        addresses: {
          full_address: null,
        },
        bank_account: {},
        comment: null,
      },
    }
  },
  methods: {
    editing(id) {
      this.loading = true
      this.loadingText = "Carregando"
      setTimeout(() => {
        // this.$router.push('/clients/'+id)
      }, 1200);
      Api.Supplier.show(id)
        .then(response=>response.data)
        .then(user=>{
          this.one_supplier = {
            ...user.data.attributes,
            is_natural: !(this.one_supplier.corporate_info && this.one_supplier.corporate_info.hasOwnProperty('corporate_name')),
            bank_account: user.data.attributes.bank_account? { ...user.data.attributes.bank_account} : {bank: null, account: null, agency: null, kind: null},
            addresses: user.data.attributes.addresses? { ...user.data.attributes.addresses} : { full_address: null}
          }

          // this.one_supplier.
          this.loading = false
          this.loadingText = null
          this.dialog_supplier = true
        })
    },
    deleting(id) {
      this.loading = false
      this.loading = true
      this.loadingText = "Apagando"
      setTimeout(() => {
        // this.updateToDelete(id)
      }, 1200);
    },
    ...mapActions({
      indexSupplier: 'Supplier/index',
      // function: 'Module/action'
    })
  },
  computed: {
    allSuppliers_comp() {
      if(this.allSuppliers){
        return this.allSuppliers 
      }
    },
    ...mapState({
      allSuppliers: state => state.Supplier.allSuppliers,
      createSupplierWasGood: state => state.Supplier.createSupplierWasGood,
      updateSupplierWasGood: state => state.Supplier.updateSupplierWasGood,

      // data: state=> state.Module.state_var
    })
  },
  mounted () {
    this.indexSupplier()
  },
  watch: {
    createSupplierWasGood(nv,ov) {
      if (nv){
        this.indexSupplier()
      } else if (nv == false){
        
      }
    },
    updateSupplierWasGood(nv,ov) {
      if (nv){
        this.indexSupplier()
      } else if (nv == false){
        
      }
    },
    

    dialog_supplier(nv,ov) {
      if (nv){
      } else if (nv == false){
        setTimeout(() => {
          this.one_supplier = {
            name: null,
            is_natural: true,
            corporate_info: {},
            phones: [],
            email: null,
            addresses: {
              full_address: null,
            },
            bank_account: {},
            comment: null,
          }
        }, 300);
      }
    }
  },
}
</script>

<style scoped>

</style>